/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindOneQueryResponse, ApplicationsControllerFindOnePathParams, ApplicationsControllerFindOneQueryParams, ApplicationsControllerFindOne400, ApplicationsControllerFindOne401, ApplicationsControllerFindOne403, ApplicationsControllerFindOne404 } from "../../models/checklistsController/ApplicationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationsControllerFindOne } from "../../clients/checklistsService/applicationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationsControllerFindOneQueryKey = (id: ApplicationsControllerFindOnePathParams["id"], params: ApplicationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-applications/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ApplicationsControllerFindOneQueryKey = ReturnType<typeof applicationsControllerFindOneQueryKey>;
export function applicationsControllerFindOneQueryOptions(id: ApplicationsControllerFindOnePathParams["id"], params?: ApplicationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationsControllerFindOneQueryKey(id, params);
  return queryOptions<ApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationsControllerFindOne400 | ApplicationsControllerFindOne401 | ApplicationsControllerFindOne403 | ApplicationsControllerFindOne404>, ApplicationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist application by ID
 * {@link /api/v1/checklist-applications/:id}
 */
export function useApplicationsControllerFindOne<TData = ApplicationsControllerFindOneQueryResponse, TQueryData = ApplicationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ApplicationsControllerFindOneQueryKey>(id: ApplicationsControllerFindOnePathParams["id"], params?: ApplicationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationsControllerFindOne400 | ApplicationsControllerFindOne401 | ApplicationsControllerFindOne403 | ApplicationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...applicationsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationsControllerFindOne400 | ApplicationsControllerFindOne401 | ApplicationsControllerFindOne403 | ApplicationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}